var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_alt_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/communication/list_alt_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 2.5H3.25C2.83333 2.5 2.5 2.83333 2.5 3.25V16.75C2.5 17.0833 2.83333 17.5 3.25 17.5H16.75C17.0833 17.5 17.5 17.0833 17.5 16.75V3.25C17.5 2.83333 17.0833 2.5 16.75 2.5ZM7.50009 5.83336H5.83343V7.50002H7.50009V5.83336ZM14.1666 5.83336H9.16657V7.50002H14.1666V5.83336ZM14.1666 9.16664H9.16657V10.8333H14.1666V9.16664ZM9.16657 12.5H14.1666V14.1667H9.16657V12.5ZM5.83343 9.16664H7.50009V10.8333H5.83343V9.16664ZM7.50009 12.5H5.83343V14.1667H7.50009V12.5ZM4.16657 15.8333H15.8332V4.16664H4.16657V15.8333Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAlt);
export default __webpack_public_path__ + "static/media/list_alt.8f6c20e5b4d7be4de35db44e9435fbf9.svg";
export { ForwardRef as ReactComponent };